import { useContext } from 'react';

import AuthContext from 'layout/Auth/context/AuthContext';

const useAuth = () => {
	return useContext(AuthContext);
};

export default useAuth;
